import { PrizmLanguageColumnSettings } from '../../interfaces';

export const PRIZM_RUSSIAN_COLUMN_SETTINGS: PrizmLanguageColumnSettings = {
  columnSettings: {
    title: 'Настройки таблицы',
    subTitle: 'Заголовок списка',
    resetBtn: 'Сбросить',
    showAllBtn: 'Показать все',
    cancelBtn: 'Отменить',
    saveBtn: 'Сохранить',
    fixHeaderToggle: 'Фиксировать шапку при скролле',
    stickyLeft: 'Фиксированные колонки слева',
    mainColumns: 'Колонки',
    stickyRight: 'Фиксированные колонки справа',
    dropzone: 'Перетащите колонку',
    disabledHint: 'Нельзя скрыть последнюю колонку',
  },
};
